import { WorkgroupGroupItemsValues, WorkgroupGroupValues } from './types';

export const WORKGROUP_ITEMS_INITIAL_VALUES: WorkgroupGroupItemsValues =
  {
    workgroupId: null,
  };

export const WORKGROUP_INITIAL_VALUES: WorkgroupGroupValues = {
  name: null,
  description: null,
  workgroupGroupItems: [],
};
